// See worker-loader-mock why this is needed
export function loadWorker() {
  return new Worker(new URL('./concept-model.worker.ts', import.meta.url));
}
